import useMode from '../stores/mode';

function Intro() {
    const mode = useMode();

    return (
        <section
            className="Intro"
            onClick={() => {
                mode.set('ar');
            }}
        >
            <h2 className="Intro-title">Discover interactive content with your phone’s camera</h2>

            <img src="images/intro--visual.svg" className="Intro-visual" />

            <button className="Intro-start">Start</button>
        </section>
    );
}

export default Intro;
